module.exports = __webpack_public_path__ + "static/img/pipeline-pump_256.c7934d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pipeline-pump_256.png
// module id = 139B
// module chunks = 0